import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';

interface Props { 
    setupIntentId: any; 
}; 

const UpdateCardElement: React.FC<Props> = ({ setupIntentId }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const stripe = useStripe();
    const elements = useElements();

    const colors = useAppSelector(state => state.theme.colors); 

    const [errorMessage, setErrorMessage] = useState(null);

    // -- 

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
        // Stripe.js hasn't yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return null;
        }

        const {error} = await stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements,
        confirmParams: {
            return_url: `${process.env.REACT_APP_BACKEND_URL}/group/intent/${setupIntentId}`,
        },
        }) as any; 

        if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        setErrorMessage(error.message);
        } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
        }
    };


    return (

        <>

            <CardElement id='card-element' />

            <Button 
                title='continue'
                triggerFunction={handleSubmit}
                extraStyle={{ 
                    width: 300, 
                    borderRadius: 2,
                    marginTop: 3, 
                    marginBottom: 6,  
                }}
            />
        
        </>

  );

};

export default UpdateCardElement;